import script from "./SeatsPerDiscipline.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeatsPerDiscipline.vue?vue&type=script&setup=true&lang=ts"

import "./SeatsPerDiscipline.vue?vue&type=style&index=0&id=215090cc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215090cc"]])

export default __exports__